// @ts-nocheck
/* eslint-disable */
import LayerPano from "~/es6/layer-pano";
import { CONFIG } from "~/config";
import SceneCoords from "~/scene/common/coords";
import { WindyWebcamMarker } from "~/windy-webcam/marker";
import { store } from "~/state/store";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";
import { MarkerGEO } from "~/marker.geo";

export default class MapVisualiser {
	_storeUnsubscribe: Unsubscribe;

	constructor(mapProvider) {
		this._mapProvider = mapProvider;
		 // scene itemId = smap object
		this._mapping = {};

		this._layers = [];
		this._controls = [];
	}

	/**
	 * Vola se pri deaktivaci provideru.
	 */
	clear() {
		let map = this._mapProvider.getMap();

		// odvesime navesene vrstvy
		this._layers.forEach(layer => {
			let smapLayer = this._getSmapItem(layer);

			if (smapLayer) {
				smapLayer.removeAll();
				smapLayer.disable();
				map.removeLayer(smapLayer);

				if (layer.appended && layer.sceneOwner == this._mapProvider.getScene()) {
					smapLayer.$destructor();
				}
			}
		});

		this._layers = [];

		// prvky nad mapou
		this._controls.forEach(control => {
			let smapControl = this._getSmapItem(control);

			if (smapControl) {
				map.removeControl(smapControl);
			}
		});

		this._controls = [];

		for (let id in this._mapping) {
			let item = this._mapping[id].scene;
			let info = item.featureInfo;

			switch (info.type) {
				case "layer":
				case "control":
					break;

				case "geometry":
				case "marker":
				case "pano":
					this._deleteItem(item);
			}
		}

		this._mapping = {};
	}

	/**
	 * Konvertovani souradnic sceny pro mapu
	 *
	 * @param  {SceneCoords|Array[SceneCoords]} coords Vstupni souradnice
	 * @return {SMap.Coords|Array[SMap.Coords]} Vystupni souradnice
	 */
	convertCoords(coords) {
		if (!coords) return null;

		let isArray = Array.isArray(coords);
		let all = isArray ? coords : [coords];
		let output = [];

		all.forEach(item => {
			if (item instanceof SceneCoords) {
				let data = item.toWGS84();

				output.push(SMap.Coords.fromWGS84(data[0], data[1]));
			}
			else {
				output.push(item);
			}
		});

		if (isArray) {
			return output;
		}
		else {
			return (output.length == 1 ? output[0] : null);
		}
	}

	/**
	 * Pro prislusnou entitu nad mapou najde jeji reprezentaci ve scene.
	 *
	 * @param  {SMap Item} smapItem Prvek nad mapou
	 * @return {SceneFeature} Entita ve scene
	 */
	getSceneItem(smapItem) {
		let sceneItem = null;

		for (let id in this._mapping) {
			let item = this._mapping[id];

			if (item.smap == smapItem) {
				sceneItem = item.scene;
				break;
			}
		}

		return sceneItem;
	}

	/**
	 * Pridani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 * @param {Boolean} [before = false] Pripnout uplne nahoru?
	 */
	addLayer(layer, before) {
		let smapLayer = this._getSmapItem(layer);
		let map = this._mapProvider.getMap();

		// pokud je jiz pridana, nepridavame
		if (!map || this._layers.indexOf(layer) != -1 || !smapLayer) return;

		map.addLayer(smapLayer, before);

		this._layers.push(layer);
	}

	/**
	 * Odebrani vrstvy.
	 *
	 * @param {SceneLayer} layer Vrstva
	 */
	removeLayer(layer) {
		let ind = this._layers.indexOf(layer);

		if (ind != -1) {
			this._layers.splice(ind, 1);

			let map = this._mapProvider.getMap();
			let smapLayer = this._getSmapItem(layer);

			if (map && smapLayer) {
				map.removeLayer(smapLayer);
			}
		}
	}

	removeCard() {
		let map = this._mapProvider.getMap();
		map.removeCard();
	}

	/**
	 * Pridani ovladaciho prvku.
	 *
	 * @param {SceneControl} control
	 */
	addControl(control) {
		let smapControl = this._getSmapItem(control);
		let map = this._mapProvider.getMap();

		// pokud je jiz pridana, nepridavame
		if (!map || this._controls.indexOf(control) != -1 || !smapControl) return;

		map.addControl(smapControl);
		this._controls.push(control);
	}

	/**
	 * Odebrani ovladaciho prvku.
	 *
	 * @param {SceneControl} control
	 */
	removeControl(control) {
		let ind = this._controls.indexOf(control);

		if (ind != -1) {
			this._controls.splice(ind, 1);

			let map = this._mapProvider.getMap();
			let smapControl = this._getSmapItem(control);

			if (map && smapControl) {
				map.removeControl(smapControl);
			}
		}
	}

	getPanoDataUrl(pano) {
		let smapPano = this._getSmapItem(pano);

		if (smapPano) {
			return smapPano.getRenderer().getDataUrl();
		}

		return "";
	}

	/**
	 * Vytvoreni markeru.
	 *
	 * @param  {SceneMarker} marker
	 */
	createMarker(marker) {
		// jiz existuje
		if (this._getMappingItem(marker)) return;

		let fi = marker.featureInfo;
		let data = marker.getCreateData();
		let smapCoords = this.convertCoords(data.coords);
		let setCoords = false;

		switch (fi.name) {
			case "SceneMarker":
				this._saveEntity(marker, new SMap.Marker(smapCoords, data.id, data.options));
				break;

			case "SceneMarkerGEO":
				this._saveEntity(marker, new MarkerGEO(smapCoords));
				break;

			case "SceneMarkerPOI":
				if (data.fromData) {
					this._saveEntity(marker, SMap.Marker.POI.fromData(data.fromData));
				}
				else {
					this._saveEntity(marker, new SMap.Marker.POI(smapCoords, data.id, data.options));
				}
				break;

			case "SceneMarkerFotoPOI":
				let markerInstance;

				if (data.fromData) {
					markerInstance = SMap.Marker.FotoPOI.fromData(data.fromData);
				}
				else {
					markerInstance = new SMap.Marker.FotoPOI(smapCoords, data.id, data.options);
				}

				if (data.source === "foto") {
					let cont = markerInstance.getContainer()[SMap.LAYER_MARKER];
					cont.classList.add("marker-foto");

					let a = cont.querySelector("a");
					if (a) {
						a.setAttribute("data-log-ignore", "1");
					}
				}

				this._saveEntity(marker, markerInstance);

				break;

			case "SceneMarkerWindyWebcam": {
					const markerInstance = WindyWebcamMarker.fromData(data.fromData);

					this._saveEntity(marker, markerInstance);
					break;
				}

			case "SceneMarkerPano":
			case "SceneMarkerMapyPano":
				let ctor = fi.name === "SceneMarkerPano" ? SMap.Pano.Marker : Mapy.Pano.Marker;
				let options = {};

				Object.keys(data.options).forEach(key => {
					// url a anchor preskocime
					if (["url", "anchor"].indexOf(key) != -1) return;
					options[key] = data.options[key];
				});

				this._saveEntity(marker, new ctor(smapCoords, data.id, options));
				break;

			case "SceneMarkerWindy":
				if (data.fromPOI) {
					this._saveEntity(marker, SMap.WMMarker.fromPOI(data.fromPOI.poi, data.fromPOI.id, data.fromPOI.opts));
				}
				else {
					this._saveEntity(marker, new SMap.WMMarker(smapCoords, data.id, data.options));
				}
				break;

			case "SceneMarkerMapyWindy":
				if (data.fromData) {
					this._saveEntity(marker, Mapy.MarkerPOI.fromData(data.fromData));
				}
				else if (data.fromPOI) {
					this._saveEntity(marker, Mapy.MarkerPOI.fromPOI(data.fromPOI.poi, data.fromPOI.id, data.fromPOI.opts));
				}
				else {
					this._saveEntity(marker, new Mapy.MarkerPOI(smapCoords, data.id, data.options));
				}
				break;

			case "SceneMarkerMapyWindyDetail":
				if (data.fromPOI) {
					let opts = null;

					if (data.fromPOI.opts) {
						opts = Object.assign({}, data.fromPOI.opts);

						if (opts.fromMarker) {
							opts.fromMarker = this._getSmapItem(opts.fromMarker);
						}
					}

					this._saveEntity(marker, Mapy.MarkerDetail.fromPOI(data.fromPOI.poi, data.fromPOI.id, opts));
				}
				break;

			case "SceneMarkerMapyWindySearch":
				if (data.fromPOI) {
					this._saveEntity(marker, Mapy.MarkerSearch.fromPOI(data.fromPOI.poi, data.fromPOI.id, data.fromPOI.opts));
				}
				break;

			case "SceneMarkerFavorite":
				this._saveEntity(marker, new Mapy.MarkerFavorite(smapCoords, data.item, data.options, data.id));
				break;

			case "SceneMarkerMapyWindyPlace":
				this._saveEntity(marker, new Mapy.MarkerPlace(smapCoords, data.item, data.options, data.id));
				break;

			case "SceneMarkerBubble":
				this._saveEntity(marker, new Mapy.MarkerBubble(smapCoords, data.id, data.options));
				break;

			case "SceneMarkerBubblePubt":
				this._saveEntity(marker, new Mapy.MarkerBubblePubt(smapCoords, data.id, data.options));
				break;
		}

		if (data.isDraggable) {
			// decorate
			this.markerDecorateDraggable(marker);
		}

		if (smapCoords && setCoords) {
			this.markerSetCoords(marker, data.coords);
		}

		if ("angle" in data && typeof data.angle === "number") {
			this.markerPanoSetAngle(marker, data.angle);
		}

		if ("visual" in data && Object.keys(data.visual).length) {
			this.markerPOISetVisual(marker, data.visual);
		}

		if ("source" in data && data.source) {
			this.markerPOISetSource(marker, data.source);
		}

		if ("plainId" in data && data.plainId) {
			this.markerPOISetPlainId(marker, data.plainId);
		}

		if ("activeState" in data) {
			this.markerPOISetActive(marker, data.activeState.state, data.activeState.noAnim);
		}

		if ("cardOpts" in data) {
			this.markerPOISetCardOptions(marker, data.cardOpts);
		}

		if ("title" in data) {
			this.markerMapyWMSetTitle(marker, data.title);
		}

		if (data.popupData) {
			this.markerPOISetPopupFromPOI(marker, data.popupData);
		}

		if (typeof data.popupCb === "function") {
			this.markerPOISetPopupCb(marker, data.popupCb);
		}

		if (data.cardShowed) {
			this.markerWMShowCard(marker);
		}

		if (data.cardRemoved) {
			this.markerPOIRemoveCard(marker);
		}

		if (data.poi) {
			this.markerWMSetPOI(marker, data.poi);
		}

		if ("active" in data) {
			this.markerWMSetActive(marker, data.active);
		}

		this._postOperations(marker);
	}

	/**
	 * Vytvoreni vrstvy.
	 *
	 * @param  {SceneLayer} layer
	 */
	createLayer(layer) {
		// jiz existuje
		if (this._getMappingItem(layer)) return;

		let fi = layer.featureInfo;
		let data = layer.getCreateData();

		switch (fi.name) {
			case "SceneLayerMapyLookup":
				this._saveEntity(layer, new Mapy.Lookup(data.id));

				// vrstvy
				data.filters.marker.forEach(markerLayer => {
					this.layerMapyLookupAddMarkerLayer(layer, markerLayer.layer, markerLayer.sources, markerLayer.types);
				});

				data.filters.geometry.forEach(geometryLayer => {
					this.layerMapyLookupAddGeometryLayer(layer, geometryLayer.layer, geometryLayer.sources, geometryLayer.types);
				});
				break;

			case "SceneLayerMulti":
				this._saveEntity(layer, new SMap.Layer.Multi(data.id));
				break;

			case "SceneLayerTile":
				this._saveEntity(layer, new SMap.Layer.Tile(data.id, data.url, data.options));
				break;

			case "SceneLayerGeometry":
				this._saveEntity(layer, new SMap.Layer.Geometry(data.id));

				layer.getGeometriesList().forEach(geometry => {
					this.layerGeometryAddGeometry(layer, geometry);
				});
				break;

			case "SceneLayerMasakovac":
				this._saveEntity(layer, new Mapy.Masakovac(data.id));

				// pridame markery
				this.layerMarkerAddMarkers(layer, layer.getMarkers(undefined, true));
				break;
			case "SceneLayerMarker":
				this._saveEntity(layer, new SMap.Layer.Marker(data.id));

				// pridame markery
				this.layerMarkerAddMarkers(layer, layer.getMarkers());
				break;

			case "SceneLayerCanvas":
				this._saveEntity(layer, new SMap.Layer.Canvas(data.id, data.layerId));

				data.contexts.forEach(ctx => {
					this.layerCanvasGetContext(layer, ctx.cb, ctx.scope);
				});
				break;

			case "SceneLayerTraffic":
				this._saveEntity(layer, new Mapy.LayerTraffic(data.id, data.options));

				if (data.data) {
					this.layerFillFromData(layer, data.data);
				}
				break;

			case "SceneLayerCanvasGeom":
				this._saveEntity(layer, new Mapy.LayerCanvasGeom(data.id, data.options));

				if (data.geometries.length) {
					this.layerCanvasGeomDrawGeometries(layer, data.geometries);
				}

				if (data.data) {
					this.layerFillFromData(layer, data.data);
				}

				break;

			case "SceneLayerWinter":
				this._saveEntity(layer, new Mapy.LayerWinter(data.id, data.options));

				if (data.geometries.length) {
					this.layerCanvasGeomDrawGeometries(layer, data.geometries);
				}

				if (data.data) {
					this.layerFillFromData(layer, data.data);
				}

				break;

			case "SceneLayer":
				this._saveEntity(layer, new SMap.Layer(data.id));
				break;

			case "SceneLayerPano":
				this._saveEntity(layer, new LayerPano(data.id, data.options));
				break;
		}

		const Scene = this._mapProvider.getScene();

		// pridat do mapy
		if (data.appended && data.sceneOwner == Scene) {
			this.addLayer(layer, data.before);
		}

		if (data.active && data.sceneOwner == Scene) {
			this.layerEnable(layer);
		}

		if (data.copyright) {
			this.layerSetCopyright(layer, data.copyright);
		}

		this._postOperations(layer);
	}

	/**
	 * Vytvoreni vrstvy - vrstva se vytvori jako mapset.
	 *
	 * @param  {SceneLayer} layer
	 */
	createLayerFromMapset(layer) {
		// jiz existuje
		if (this._getMappingItem(layer)) return;

		let data = layer.getCreateData();
		let smapLayer = null;

		switch (data.id) {
			case this._mapProvider.getScene().MAPSET.OBLIQUE:
			case this._mapProvider.getScene().MAPSET.OBLIQUE_HYBRID:
				smapLayer = new SMap.Layer.Tile.Oblique(data.id, data.url, data.options);
			break;

			default:
				let ctor = SMap.Layer.Tile;

				if ([this._mapProvider.getScene().MAPSET.TURIST, this._mapProvider.getScene().MAPSET.TURIST_NEW].indexOf(data.id) != -1) { ctor = SMap.Layer.Turist; }

				smapLayer = new ctor(data.id, data.url, data.options);

				if (ctor == SMap.Layer.Turist) {
					smapLayer.setBike(data.bike);
					smapLayer.setTrail(data.trail);
				}
			break;
		}

		// save
		this._saveEntity(layer, smapLayer);

		const Scene = this._mapProvider.getScene();

		// pridat do mapy
		if (data.appended && data.sceneOwner == Scene) {
			this.addLayer(layer, data.before);
		}

		if (data.active && data.sceneOwner == Scene) {
			this.layerEnable(layer);
		}

		// copyright
		this.layerSetCopyright(layer, data.copyright);

		this._postOperations(layer);
	}

	/**
	 * Vytvoreni geometrie.
	 *
	 * @param  {SceneGeometry} geometry
	 */
	createGeometry(geometry) {
		// jiz existuje
		if (this._getMappingItem(geometry)) return;

		let fi = geometry.featureInfo;
		let data = geometry.getCreateData();

		switch (fi.name) {
			case "SceneGeometryTraffic":
				this._saveEntity(geometry, SMap.Geometry.Traffic.fromData(data.data));

				if (data.disabledClick) {
					this.geometryMultiDisableClick(geometry);
				}
				break;

			case "SceneGeometryMulti":
				if (data.data?.geom?.type === "path") {
					this._saveEntity(geometry, new SMap.Geometry(SMap.GEOMETRY_PATH, data.id, [geometry.getPath()], data.options));
				} else {
					this._saveEntity(geometry, SMap.Geometry.Multi.fromData(data.data, data.options));
				}

				if (data.disabledClick) {
					this.geometryMultiDisableClick(geometry);
				}
				break;

			case "SceneGeometry":
				let smapCoords = this.convertCoords(data.coords);
				let smapType = null;

				switch (data.type) {
					case this._mapProvider.getScene().GEOMETRY.POLYLINE:
						smapType = SMap.GEOMETRY_POLYLINE;
						break;

					case this._mapProvider.getScene().GEOMETRY.PATH:
						smapType = SMap.GEOMETRY_PATH;
						break;

					case this._mapProvider.getScene().GEOMETRY.POLYGON:
						smapType = SMap.GEOMETRY_POLYGON;
						break;

					case this._mapProvider.getScene().GEOMETRY.CIRCLE:
						smapType = SMap.GEOMETRY_CIRCLE;
						break;

					case this._mapProvider.getScene().GEOMETRY.ELLIPSE:
						smapType = SMap.GEOMETRY_ELLIPSE;
						break;
				}

				if (smapType === SMap.GEOMETRY_PATH) {
					this._saveEntity(geometry, new SMap.Geometry(smapType, data.id, [geometry.getPath()], data.options));
				} else  if (smapType != null) {
					this._saveEntity(geometry, new SMap.Geometry(smapType, data.id, smapCoords, data.options));
				} else if (data.type == this._mapProvider.getScene().GEOMETRY.TRAFFICPATH) {
					this._saveEntity(geometry, new Mapy.Geometry.Path.Traffic(smapType, data.id, smapCoords, data.options));
				}
				break;
		}

		this._postOperations(geometry);
	}

	/**
	 * Vytvoreni ovladaciho prvku.
	 *
	 * @param  {SceneControl} control
	 */
	createControl(control) {
		// jiz existuje
		if (this._getMappingItem(control)) return;

		let fi = control.featureInfo;
		let data = control.getCreateData();

		switch (fi.name) {
			case "SceneControlContextMenu":
				this._saveEntity(control, new SMap.Control.ContextMenu());

				data.items.forEach(item => {
					this.controlContextMenuAddItem(control, item);
				});
				break;

			case "SceneControl":
				this._saveEntity(control, new SMap.Control());
				break;
		}

		if (data.appended) {
			this.addControl(control);
		}

		this._postOperations(control);
	}

	/**
	 * Udalost z feature - nastaveni vlastnika.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param  {SceneFeature} owner Novy vlastnik
	 */
	featureSetOwner(sceneItem, owner) {
		let smapEntity = this._getSmapItem(sceneItem);
		let smapOwner = null;

		if (owner) {
			smapOwner = owner == this ? this._mapProvider.getMap() : this._getSmapItem(owner);
		}

		if (smapEntity && smapOwner) {
			// vyzkouset
			smapEntity.setOwner(smapOwner);
		}
	}

	/**
	 * Udalost z feature - odstraneni entity.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 */
	featureDestroy(sceneItem) {
		this._deleteItem(sceneItem);

		// smazeme na scene
		this._mapProvider.getScene().deleteEntity(sceneItem);
	}

	/**
	 * Udalost z feature - ziskani DOM containeru
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 */
	featureGetContainer(sceneItem, cb, scope) {
		let cont = this._getContainer(sceneItem);

		if (cont && typeof cb === "function") {
			cb.apply(scope || cb, [cont]);
		}
	}

	/**
	 * Udalost z feature - ziskani DOM containeru, synchronni verze.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 */
	featureGetContainerSync(sceneItem) {
		return this._getContainer(sceneItem);
	}

	/**
	 * Udalost z feature - ziskani DOM containeru
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 */
	featureGetShadowContainer(sceneItem, cb) {
		let cont = this._getContainer(sceneItem, true);

		if (cont && typeof cb === "function") {
			cb.apply(cb, [cont]);
		}
	}

	/**
	 * Udalost z feature - nastaveni DOM stylu.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param {String} name Nazev stylu
	 * @param {String} value Hodnota
	 */
	featureSetStyle(sceneItem, name, value) {
		let cont = this._getContainer(sceneItem);

		if (cont && typeof name === "string" && name.length) {
			cont.style[name] = value === null ? "" : value;
		}
	}

	featureSetAttribute(sceneItem, name, value) {
		let cont = this._getContainer(sceneItem);

		if (cont instanceof Array) {
			for (let i = 0; i < cont.length; i++) {
				cont[i].setAttribute(name, value === null ? "" : value);
			}
		}
		else {
			if (cont && typeof name === "string" && name.length) {
				cont.setAttribute(name, value === null ? "" : value);
			}
		}
	}

	/**
	 * Udalost z feature - pridani event listeneru.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param {String} name Nazev udalosti
	 * @param {Function} cb Callback funkce
	 * @param {Boolean} [useCapture = false]
	 */
	featureAddEventListener(sceneItem, name, cb, useCapture) {
		let cont = this._getContainer(sceneItem);

		if (cont && typeof name === "string" && name.length) {
			cont.addEventListener(name, cb, useCapture);
		}
	}

	/**
	 * Udalost z feature - odebrani event listeneru.
	 *
	 * @param  {SceneFeature} sceneItem Volana entita
	 * @param {String} name Nazev udalosti
	 * @param {Function} cb Callback funkce
	 * @param {Boolean} [useCapture = false]
	 */
	featureRemoveEventListener(sceneItem, name, cb, useCapture) {
		let cont = this._getContainer(sceneItem);

		if (cont && typeof name === "string" && name.length) {
			cont.removeEventListener(name, cb, useCapture);
		}
	}

	/**
	 * Povoleni vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerEnable(layer) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.enable();
		}
	}

	/**
	 * Zakazani vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerDisable(layer) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.disable();
		}
	}

	/**
	 * Nastaveni copyrightu dane vrstve.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {Object} copyright Definice copyrightu
	 */
	layerSetCopyright(layer, copyright) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setCopyright(copyright);
		}
	}

	/**
	 * Vycisteni vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerClear(layer) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.clear();
		}
	}

	/**
	 * Smazani vsech entit vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 */
	layerRemoveAll(layer) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.removeAll();
		}
	}

	/**
	 * Prekresleni vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Boolean} [full] Plne prekresleni?
	 */
	layerRedraw(layer, full) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.redraw(full);
		}
	}

	/**
	 * Pridani markeru do vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMarkerAddMarkers(layer, markers, noRedraw) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.addMarker(this._getSmapMarkers(markers), noRedraw);
		}
	}

	/**
	 * Odebrani markeru z vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMarkerRemoveMarkers(layer, markers, noRedraw) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.removeMarker(this._getSmapMarkers(markers), noRedraw);
		}
	}

	/**
	 * Nastaveni redici funkce dane vrstve.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {Object} opts
	 */
	layerMarkerSetReposition(layer, opts) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setReposition(opts);
		}
	}

	/**
	 * zmena na  makerech
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {SceneMarker|Array[SceneMarker]} marker Vstupni markery
	 * @param {Boolean} noRedraw Neprekreslovat mapu
	 */
	layerMasakovacChangeMarkers(layer, markers, noRedraw) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.changeMarkers(this._getSmapMarkers(markers), noRedraw);
		}
	}

	/**
	 * Vrstva s geometrii - pridani nove geometrie.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {SceneGeometry} geometry Geometrie k pridani
	 */
	layerGeometryAddGeometry(layer, geometry) {
		let smapLayer = this._getSmapItem(layer);
		let smapGeometry = this._getSmapItem(geometry);

		if (smapLayer && smapGeometry) {
			smapLayer.addGeometry(smapGeometry);
		}
	}

	/**
	 * Vrstva s geometrii - odebrani geometrie.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {SceneGeometry} geometry Geometrie k odstraneni
	 */
	layerGeometryRemoveGeometry(layer, geometry) {
		let smapLayer = this._getSmapItem(layer);
		let smapGeometry = this._getSmapItem(geometry);

		if (smapLayer && smapGeometry) {
			try {
				smapLayer.removeGeometry(smapGeometry);
			} catch(error) {
				console.error(error);
			}
		}
	}

	/**
	 * Vrstva s dlazdici - nastaveni parametru.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Object} options Nove parametry
	 */
	layerGeometrySetOptions(layer, options) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			if ("className" in options) {
				smapLayer.getContainer()[SMap.LAYER_GEOMETRY].setAttribute("class", options.className);
			}
		}
	}

	/**
	 * Vrstva s dlazdici - nastaveni parametru.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Object} options Nove parametry
	 */
	layerTileSetOptions(layer, options) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setOptions(options);

			if ("className" in options) {
				smapLayer.getContainer()[SMap.LAYER_TILE].className = options.className;
			}
		}
	}

	/**
	 * Vrstva s dlazdici - nastaveni noveho url.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {String} url Nove url
	 */
	layerTileSetUrl(layer, url) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setUrl(url);
		}
	}

	/**
	 * Vrstva s dlazdici - rotace podle poctu stupnu.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Number} angle Uhel
	 */
	layerTileRotateTo(layer, angle) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.rotateTo(angle);
		}
	}

	/**
	 * Turisticka vrstva - nastaveni cyklotras.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Boolean} state Stav
	 */
	layerTuristSetBike(layer, state) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setBike(state);
		}
	}

	/**
	 * Turisticka vrstva - nastaveni pesich tras.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Boolean} state Stav
	 */
	layerTuristSetTrail(layer, state) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.setTrail(state);
		}
	}

	/**
	 * Multi vrstva - upravena pro mapy, pridani vrstvy s markery
	 *
	 * @param  {SceneLayer} sceneLayer Volana vrstva
	 * @param {SceneLayerMarker} layer
	 * @param {Array} sources Ktere zdroje bude obsluhovat?
	 * @param {Array} types Seznam typu
	 */
	layerMapyLookupAddMarkerLayer(sceneLayer, layer, sources, types) {
		let smapLayer = this._getSmapItem(sceneLayer);
		let smapLayerAdd = this._getSmapItem(layer);

		if (smapLayer && smapLayerAdd) {
			smapLayer.addMarkerLayer(smapLayerAdd, sources, types);
		}
	}

	/**
	 * Multi vrstva - upravena pro mapy, pridani vrstvy s geometrii
	 *
	 * @param  {SceneLayer} sceneLayer Volana vrstva
	 * @param {SceneLayerGeometry} layer
	 * @param {Array} sources Ktere zdroje bude obsluhovat?
	 * @param {Array} types Seznam typu
	 */
	layerMapyLookupAddGeometryLayer(sceneLayer, layer, sources, types) {
		let smapLayer = this._getSmapItem(sceneLayer);
		let smapLayerAdd = this._getSmapItem(layer);

		if (smapLayer && smapLayerAdd) {
			smapLayer.addGeometryLayer(smapLayerAdd, sources, types);
		}
	}

	/**
	 * Pridani vrstvy do multi vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {SceneLayer} addLayer Vrstva k pridani
	 */
	layerMultiAddLayer(layer, addLayer) {
		let smapLayer = this._getSmapItem(layer);
		let smapLayerAdd = this._getSmapItem(addLayer);

		if (smapLayer && smapLayerAdd) {
			smapLayer.addLayer(smapLayerAdd);
		}
	}

	/**
	 * Odebrani vrstvy z multi vrstvy.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {SceneLayer} removeLayer Vrstva k odebrani
	 */
	layerMultiRemoveLayer(layer, removeLayer) {
		let smapLayer = this._getSmapItem(layer);
		let smapLayerRemove = this._getSmapItem(removeLayer);

		if (smapLayer && smapLayerRemove) {
			smapLayer.removeLayer(smapLayerRemove);
		}
	}

	/**
	 * Canvas vrstva - callback s kontextem.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 */
	layerCanvasGetContext(layer, cb, scope) {
		let smapLayer = this._getSmapItem(layer);
		let ctx = smapLayer.getContext();

		if (ctx && typeof cb === "function") {
			cb.apply(scope || cb, [ctx]);
		}
	}

	/**
	 * Canvas vrstva pro vykresleni trafficu.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param {Array} data Data z lookupu
	 */
	layerFillFromData(layer, data) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.fillFromData(data);
		}
	}

	/**
	 * Canvas vrstva pro vykresleni svg geometrii.
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Array} geometries Pole geometrii
	 * @param {Array} data Data z lookupu
	 */
	layerCanvasGeomDrawGeometries(layer, geometries) {
		let smapLayer = this._getSmapItem(layer);

		if (smapLayer) {
			smapLayer.drawGeometries(geometries);
		}
	}

	/**
	 * Canvas vrstva pro vykresleni svg geometrii - je na pozici x, y geometrie?
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Number} x Pozice X
	 * @param  {Number} y Pozice Y
	 * @return {Boolean}
	 */
	layerCanvasGeomGeometryOnCursor(layer, x, y) {
		let smapLayer = this._getSmapItem(layer);

		return (smapLayer ? smapLayer.geometryOnCursor(x, y) : false);
	}

	/**
	 * Canvas vrstva pro vykresleni svg geometrii - vraceni canvas elementu
	 *
	 * @param  {SceneLayer} layer Volana vrstva
	 * @param  {Number} x Pozice X
	 * @param  {Number} y Pozice Y
	 * @return {Boolean}
	 */
	layerCanvasGeomGetCanvas(layer) {
		let smapLayer = this._getSmapItem(layer);

		return (smapLayer ? smapLayer.getCanvas() : false);
	}

	layerCanvasGeomUp(layer) {
		let smapLayer = this._getSmapItem(layer);

		return (smapLayer ? smapLayer.up() : false);
	}

	layerCanvasGeomDown(layer) {
		let smapLayer = this._getSmapItem(layer);

		return (smapLayer ? smapLayer.down() : false);
	}

	layerPanoSetLine(layer, state) {
		let smapLayer = this._getSmapItem(layer);

		smapLayer?.setLine(state);
	}

	/**
	 * Nastaveni souradnic u znacky.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {SceneCoords} coords Nove souradnice
	 */
	markerSetCoords(marker, coords) {
		let smapMarker = this._getSmapItem(marker);
		let smapCoords = this.convertCoords(coords);

		if (smapMarker) {
			smapMarker.setCoords(smapCoords);
		}
	}

	/**
	 * Marker se stane presunovatelnym.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 */
	markerDecorateDraggable(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.decorate(SMap.Marker.Feature.Draggable);
		}
	}

	/**
	 * Markeru se nastavi priznak drag.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {Boolean} state Stav
	 */
	markerSetDrag(marker, state) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setDrag(state);
		}
	}

	/**
	 * Markeru se nastavi stav mouse over.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 */
	markerMapyMouseOver(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.mouseOver();
		}
	}

	/**
	 * Markeru se nastavi stav mouse out.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 */
	markerMapyMouseOut(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.mouseOut();
		}
	}

	/**
	 * Nastavi POI markeru novy zdroj.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {String} source Novy zdroj
	 */
	markerPOISetSource(marker, source) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setSource(source);
		}
	}

	/**
	 * Nastavi POI markeru nove ID.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {Number} source Nove ID
	 */
	markerPOISetPlainId(marker, plainId) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setPlainId(plainId);
		}
	}

	/**
	 * Nastavi POI markeru novy vzhled.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {Object} visual Konfigurace s novym vzhledem
	 */
	markerPOISetVisual(marker, visual) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setVisual(visual);
		}
	}

	/**
	 * Nastavi POI markeru jestli je aktivni.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {Boolean} state Novy stav
	 * @param {Boolean} [noAnim = false] Neanimovat
	 */
	markerPOISetActive(marker, state, noAnim) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setActive(state, noAnim);
		}
	}

	/**
	 * Nastavi POI markeru vyjizdeci kartu (bublinu)
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Function} cb Callback funkce
	 */
	markerPOISetPopupCb(marker, cb) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setPopupCallback(cb);
		}
	}

	/**
	 * Nastavi POI markeru konfiguraci pro kartu.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Object} options Konfigurace
	 */
	markerPOISetCardOptions(marker, options) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setCardOptions(options);
		}
	}

	markerWMShowCard(marker, timeout, noSendSignal) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.showCard(timeout, noSendSignal);
		}
	}

	/**
	 * Odebere POI markeru kartu.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 */
	markerPOIRemoveCard(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.removeCard();
		}
	}

	markerPOIClearCard(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker._card.obj = null;
			smapMarker._card.fill = false;
		}
	}

	/**
	 * Prepocita POI markeru novou pozici karty.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 */
	markerPOIMoveCard(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.moveCard();
		}
	}

	markerWMGetCard(marker) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			return smapMarker.getCard();
		}
	}

	markerWMSetLabel(marker, label) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setLabel(label);
		}
	}

	markerMapyWMSetTitle(marker, title) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setTitle(title);
		}
	}

	markerMapyWMShowTitle(marker, show, position) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.showTitleText(show, position);
		}
	}

	markerMapyWMShowFirmBadge(marker, show) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.showFirmBadge(show);
		}
	}

	markerMapyWMSetInteractive(marker, set) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setInteractive(set);
		}
	}

	markerMapyWMSetNonInteractive(marker, set) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setNonInteractive(set);
		}
	}

	markerMapyWMPaddingPosition(marker, paddingPosition) {
		if (paddingPosition) {
			const scene = this._mapProvider.getScene();
			let pixel = scene.coordsToPixel(marker.getCoords());
			pixel.x = pixel.x + (paddingPosition.left || 0);
			pixel.y = pixel.y + (paddingPosition.top || 0);

			marker.setCoords(scene.pixelToCoords(pixel));
		}
	}

	/**
	 * Vrati vertikalni anchor vizitky markeru pro dany typ
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {String} typeName Nazev typu markeru
	 */
	 markerGetCardAnchor(marker, typeName) {
		let smapMarker = this._getSmapItem(marker);
		if (smapMarker) {
			return smapMarker.getCardAnchor(typeName);
		}
	}

	/**
	 * Nastavi markeru novy typ.
	 *
	 * @param  {SceneMarker} marker Volany marker
	 * @param  {String} typeName Nazev typu markeru
	 */
	 markerSetType(marker, typeName) {
		let smapMarker = this._getSmapItem(marker);
		if (smapMarker) {
			smapMarker.setType(typeName);
		}
	}

	/**
	 * Vytvori POI markeru kartu ze vstupnich POI dat.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Object} data Vstupni data
	 */
	markerPOISetPopupFromPOI(marker, data) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setPopupFromPOI(data);
		}
	}

	/**
	 * Windy markeru nastavi POI data.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Object} poi POI data
	 */
	markerWMSetPOI(marker, poi) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setPOI(poi);
		}
	}

	/**
	 * Nastaví Windy markeru stav.
	 *
	 * @param  {SceneMarker}   marker Volany marker
	 * @param  {Boolean} state Novy stav
	 */
	markerWMSetActive(marker, state) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setActive(state);
		}
	}

	markerPanoSetAngle(marker, angle) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setAngle(angle);
		}
	}

	markerBubbleSetArrowAngle(marker, angle) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			return smapMarker.setArrowAngle(angle);
		}

		return null;
	}

	markerBubbleSetInnerElement(marker, elm) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setInnerElement(elm);
		}
	}

	markerBubbleToggleClassName(marker, method, className) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.toggleClassName(method, className);
		}
	}

	markerBubbleSetInnerElement(marker, element) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setInnerElement(element);
		}
	}

	markerBubbleSetOptions(marker, options) {
		let smapMarker = this._getSmapItem(marker);

		if (smapMarker) {
			smapMarker.setOptions(options);
		}
	}

	/**
	 * Nastaveni konfigurace u geometrie.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 * @param  {Object} options Konfigurace
	 */
	geometrySetOptions(geometry, options) {
		let smapGeometry = this._getSmapItem(geometry);

		if (smapGeometry) {
			smapGeometry.setOptions(options);
		}
	}

	/**
	 * Vycisteni geometrie.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 */
	geometryClear(geometry) {
		let smapGeometry = this._getSmapItem(geometry);

		if (smapGeometry) {
			smapGeometry.clear();
		}
	}

	/**
	 * Nastaveni souradnic u geometrie.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 * @param  {SceneCoords} coords Nove souradnice
	 */
	geometrySetCoords(geometry, coords) {
		let smapGeometry = this._getSmapItem(geometry);
		let smapCoords = this.convertCoords(coords);

		if (smapGeometry) {
			smapGeometry.setCoords(smapCoords);
		}
	}

	geometrySetPath(geometry, path) {
		let smapGeometry = this._getSmapItem(geometry);

		if (smapGeometry) {
			smapGeometry.setCoords(path);
		}
	}

	/**
	 * Ziskani SVG uzlu u geometrie.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 */
	geometryGetNodes(geometry, cb, scope) {
		let smapGeometry = this._getSmapItem(geometry);

		if (smapGeometry && typeof cb === "function") {
			cb.apply(scope || cb, [smapGeometry.getNodes()]);
		}
	}

	/**
	 * Ziskani SVG nodu geometrie - synchronni verze.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 * @return {Array} pole s geometriemi
	 */
	geometryGetNodesSync(geometry) {
		let smapGeometry = this._getSmapItem(geometry);

		return (smapGeometry ? smapGeometry.getNodes() : []);
	}

	/**
	 * Zruseni posluchace na kliknuti u geometrie.
	 *
	 * @param  {SceneGeometry} geometry Volana geometrie
	 */
	geometryMultiDisableClick(geometry) {
		let smapGeometry = this._getSmapItem(geometry);

		if (smapGeometry) {
			smapGeometry.click = function() {};
		}
	}

	/**
	 * Nastaveni souradnic u ovladaciho prvku kapky.
	 *
	 * @param  {SceneControl} control Volany ovladaci prvek
	 * @param  {SceneCoords} coords Nove souradnice
	 * @param  {Boolean} alwaysShow zobrazovat vzdy
	 */
	controlDropSetCoords(control, coords, alwaysShow) {
		let smapControl = this._getSmapItem(control);
		let smapCoords = this.convertCoords(coords);

		if (smapControl) {
			smapControl.setCoords(smapCoords, alwaysShow);
		}
	}

	/**
	 * Pridani polozky do kontextoveho menu.
	 *
	 * @param  {SceneControl} control Volany ovladaci prvek
	 * @param  {Object} item Nova polozka
	 */
	controlContextMenuAddItem(control, item) {
		let smapControl = this._getSmapItem(control);

		if (smapControl) {
			smapControl.addItem(item);
		}
	}

	/**
	 * Otevreni kontextoveho menu.
	 *
	 * @param  {SceneControl} control Volany ovladaci prvek
	 * @param  {Event} e Event
	 */
	controlContextMenuOpen(control, e) {
		let smapControl = this._getSmapItem(control);

		if (smapControl) {
			smapControl.open(e);
		}
	}

	/**
	 * Zavreni kontextoveho menu.
	 *
	 * @param  {SceneControl} control Volany ovladaci prvek
	 * @param  {Event} e Event
	 */
	controlContextMenuClose(control, e) {
		let smapControl = this._getSmapItem(control);

		if (smapControl) {
			smapControl.close(e);
		}
	}

	/**
	 * Zobrazeni pano sceny.
	 *
	 * @param  {ScenePanoScene} pano Volana pano scena
	 * @param {SMap.Pano.Place} place Misto k zobraeni
	 * @param {Object} opts Konfigurace kamery
	 * @param {Boolean} [options.blend=false] Pomocí animovaného prolnutí?
	 * @param {String || Number || Null} [options.yaw] Horizontální natočení: null => zachovat existující yaw, "auto" => použít spočítánou hodnotu pro panoramatu nebo se použije kappa, číslo = úhel (v radiánech)
	 * @param {String || Number || Null} [options.fov] Horizontální field of view: null => zachovat existující fov, "auto" => převzít ze scény, číslo = úhel (v radiánech)
	 * @param {String || Number || Null} [options.pitch] Vertikální natočení: null => zachovat existující pitch, "auto" => převzít ze scény, číslo = úhel (v radiánech)
	 */
	panoShow(pano, place, opts) {
		let smapPano = this._getSmapItem(pano);

		if (smapPano) {
			smapPano.show(place, opts);
		}
	}

	/**
	 * Nastaveni kamery u pano sceny.
	 *
	 * @param  {ScenePanoScene} pano Volana pano scena
	 * @param {Object} opts Objekt s klici:: fov, yaw, pitch.
	 */
	panoSetCamera(pano, opts) {
		let smapPano = this._getSmapItem(pano);

		if (smapPano) {
			smapPano.setCamera(opts);
		}
	}

	/**
	 * Synchronizace rozmeru u pano sceny.
	 *
	 * @param  {ScenePanoScene} pano Volana pano scena
	 */
	panoSyncPort(pano) {
		let smapPano = this._getSmapItem(pano);

		if (smapPano) {
			smapPano.syncPort();
		}
	}

	panoAddTimeline(pano, el, cb) {
		const smapPano = this._getSmapItem(pano);
		smapPano?.addTimeline(el, cb);
	}

	/**
	 * prekresleni sceny panoramy.
	 *
	 * @param  {ScenePanoScene} pano Volana pano scena
	 */
	redraw(pano) {
		let smapPano = this._getSmapItem(pano);

		if (smapPano) {
			smapPano.redraw();
		}
	}

	/**
	 * Ziskani entity nad mapou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt ze sceny
	 * @return {SMap Item}
	 */
	_getSmapItem(sceneItem) {
		let mapItem = this._getMappingItem(sceneItem);

		return (mapItem ? mapItem.smap : null);
	}

	/**
	 * Ziskani mapovaci objektu.
	 *
	 * @param  {SceneFeature} sceneItem Objekt ze sceny
	 * @return {Object}
	 */
	_getMappingItem(sceneItem) {
		return (sceneItem.itemId in this._mapping ? this._mapping[sceneItem.itemId] : null);
	}

	/**
	 * Ulozeni smap entity, ktere je reprezentovana entitou nad scenou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt ze sceny
	 * @param  {SMap Item} smapEntity Objekt nad mapou
	 */
	_saveEntity(sceneItem, smapEntity) {
		this._mapping[sceneItem.itemId] = {
			smap: smapEntity,
			scene: sceneItem
		};
	}

	/**
	 * Odstraneni smap entity, ktera je reprezentovana entitou nad scenou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt nad scenou
	 */
	_deleteItem(sceneItem) {
		let mappingItem = this._getMappingItem(sceneItem);

		if (mappingItem) {
			if (typeof mappingItem.smap.$destructor === "function") {
				mappingItem.smap.$destructor();
			}
		}

		delete this._mapping[sceneItem.itemId];
	}

	/**
	 * Hlavni funkce, ktera vraci obal DOM elementu nad mapou.
	 *
	 * @param  {SceneFeature} sceneItem Objekt nad scenou
	 * @param  {boolean} shadow shadow layer markeru
	 * @return {Element}
	 */
	_getContainer(sceneItem, shadow) {
		let smapItem = this._getSmapItem(sceneItem);
		let cont = null;

		if (smapItem) {
			let fi = sceneItem.featureInfo;

			if (fi.type == "marker") {
				cont = smapItem.getContainer()[SMap.LAYER_MARKER];
			}
			else if (fi.type == "geometry") {
				cont = smapItem.getNodes();
			}
			else if (fi.type == "layer") {
				switch (fi.name) {
					case "SceneLayerMasakovac":
					case "SceneLayerMarker":
						cont = smapItem.getContainer()[shadow ? SMap.LAYER_SHADOW : SMap.LAYER_MARKER];
						break;

					case "SceneLayerGeometry":
						cont = smapItem.getContainer()[SMap.LAYER_GEOMETRY];
						break;

					case "SceneLayerTile":
						cont = smapItem.getContainer()[SMap.LAYER_TILE];
						break;

					case "SceneLayerCanvas":
						cont = smapItem.getContainer()[SMap.LAYER_ACTIVE];
						break;

					case "SceneLayerCanvasGeom":
						cont = smapItem.getContainer()[SMap.LAYER_CANVAS];
						break;

					case "SceneLayer":
						cont = {};
						break;
				}
			}
			else if (fi.type == "control") {
				cont = smapItem.getContainer();
			}
		}

		return (cont ? cont : document.createElement("div"));
	}

	/**
	 * Post operace pri vytvoreni entit.
	 * Uprava stylu + eventy.
	 *
	 * @param  {SceneFeature} sceneItem Objekt nad scenou
	 */
	_postOperations(sceneItem) {
		let data = sceneItem.getCreateData();

		for (let name in data.style) {
			this.featureSetStyle(sceneItem, name, data.style[name]);
		}

		data.events.forEach(event => {
			this.featureAddEventListener(sceneItem, event.name, event.cb, event.useCapture);
		});

		if (data.attribute) {
			for (let p in data.attribute) {
				this.featureSetAttribute(p, data.attribute[p]);
			}
		}

		// pouze ty ulozene
		data.operations.forEach(contOper => {
			this.featureGetContainer(sceneItem, contOper.cb, contOper.scope);
		});
	}

	/**
	 * Pro markery ze sceny vrat jejich prislusne reprezentace v smap.
	 * Pokud marker v smap neexistuje, nevraci se.
	 *
	 * @param  {Array[this._mapProvider.getScene().Marker]} sceneMarkers Vstupni markery
	 * @return {Array[SMap.Marker]}
	 */
	_getSmapMarkers(sceneMarkers) {
		let smapMarkers = [];

		sceneMarkers.forEach(sceneMarker => {
			let smapMarker = this._getSmapItem(sceneMarker);

			if (smapMarker) {
				smapMarkers.push(smapMarker);
			}
		});

		return smapMarkers;
	}
}
